import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';

const HomePage = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        document.title = "Home - Study App";

        const fetchCategories = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/course/category`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    }
                });
                const data = await response.json();
                setCategories(data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);

    return (
        <div>
            <Header />
            <div style={{ padding: "20px", display: "flex", flexDirection: "row", gap: "50px" }}>
                <div>
                    <h1>Welcome to Our Application</h1>
                    <p>Study apps are mobile or web applications designed to help students learn, revise, and organize their studies more effectively. They combine technology with education to make studying interactive, flexible, and personalized.</p>
                    <p>These apps can include features like:</p>
                    <ul>
                        <li>Notes organization</li>
                        <li>Flashcards for revision</li>
                        <li>Progress tracking</li>
                        <li>Collaboration tools</li>
                        <li>Access to educational resources</li>
                    </ul>
                    <p>By using study apps, students can enhance their learning experience, stay motivated, and improve their academic performance.</p>
                </div>
                <div style={{ marginTop: '20px', order: '-1', backgroundColor: "lightgreen" }}>
                    <p>Courses</p>
                    {categories.map((category) => (
                        <Link key={category.id} to={`/${category.name}`}><p>{category.name}</p></Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HomePage;
